import { onAuthStateChanged } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

// Business facets are volatile and scoped; never persist them with the static catalogue.
const entries = new Map();
let generation = 0;
export const clearAuctionCatalogue = () => { generation++; entries.clear(); };
let uid = auth.currentUser?.uid;
onAuthStateChanged(auth, user => {
  if (uid !== user?.uid) { uid = user?.uid; clearAuctionCatalogue(); }
});

export async function getAuctionCatalogue(endpoint, context, filters = {}, {forceRefresh = false} = {}) {
  const currentUid = auth.currentUser?.uid;
  if (!currentUid || (!context.activeUnitId && !context.dealershipId)) return [];
  const payload = {...filters, operatingUnitId: context.activeUnitId || null,
    dealershipId: context.dealershipId || null, requestedApp: 'dealership_web'};
  const key = JSON.stringify([functions.app?.options?.projectId || null, currentUid,
    context.activeApp || 'dealership_web', payload, endpoint, [...(context.permissions || [])].sort()]);
  const cached = entries.get(key);
  if (!forceRefresh && cached && (cached.pending || cached.expires > Date.now())) return cached.value;
  const version = generation;
  const entry = {pending: true};
  entry.value = (async () => {
    try {
      const result = await httpsCallable(functions, endpoint)(payload);
      const values = Array.isArray(result.data) ? result.data : result.data?.success === 'yes' ? result.data.data : [];
      if (version === generation && auth.currentUser?.uid === currentUid && entries.get(key) === entry) {
        entry.pending = false; entry.expires = Date.now() + 30000;
      }
      return values || [];
    } catch (error) {
      if (entries.get(key) === entry) entries.delete(key);
      if (['functions/permission-denied', 'functions/unauthenticated', 'permission-denied', 'unauthenticated'].includes(error.code)) clearAuctionCatalogue();
      notifyPermissionDenied(error);
      throw error;
    }
  })();
  entries.set(key, entry);
  if (entries.size > 100) entries.delete(entries.keys().next().value);
  return entry.value;
}
